import clsx from "clsx";
import { FunctionComponent } from "react";

import AudioIcon from "@ui/components/icon/AudioIcon";
import PlayIcon from "@ui/components/icon/PlayIcon";
import VideoIcon from "@ui/components/icon/VideoIcon";

import * as styles from "./MediaIcon.css";

interface Props {
  variation: "video" | "podcast";
  placement: "title" | "thumbnail";
  inset?:
    | "small"
    | "smallMobile"
    | "medium"
    | "mediumMobile"
    | "large"
    | "default";
}

const MediaIcon: FunctionComponent<Props> = ({
  variation,
  placement,
  inset = "default",
}) => {
  if (placement === "title") {
    const Icon = variation === "video" ? VideoIcon : AudioIcon;

    return <Icon className={styles.inlineHeadlineIcon} />;
  } else {
    const Icon = variation === "video" ? PlayIcon : AudioIcon;

    return (
      <div className={clsx(styles.circle, styles.circleInset[inset])}>
        <Icon className={styles.thumbnailIcon} />
      </div>
    );
  }
};

export default MediaIcon;
